import {Action, Icon, view, tokens} from '@sail/ui';
import {chevronRight} from '@sail/icons/react/Icon';
import type {IconAsset} from '@sail/icons/types';
import {Badge, Text} from 'src/v2/components/common';
import {message, useIntl} from '@sail/intl';

const messages = {
  installed: message({
    id: 'crypto.payins.v2.wallet_select.installed',
    description: 'A badge to signal that the wallet is installed',
    defaultMessage: 'Installed',
  }),
};

type Props = {
  title: string;
  icon: IconAsset;
  onClick: () => void;
};

export const BrowserExtensionSelect = ({title, icon, onClick}: Props) => {
  const intl = useIntl();

  return (
    <Action onPress={onClick}>
      <view.div
        css={{
          stack: 'x',
          paddingY: 'medium',
          backgroundColor: 'offset',
          borderRadius: 'small',
          padding: 'space.150',
          alignItems: 'center',
          distribute: 'space-between',
          ':hover': {
            backgroundColor: tokens.color.neutral[50].toString(),
          },
        }}
      >
        <view.div
          css={{
            stack: 'x',
            gapX: 'small',
            justifyContent: 'start',
            alignItems: 'center',
          }}
        >
          <Icon icon={icon} size="large" css={{borderRadius: 'small'}} />
          <Text type="bodyEmphasized">{title}</Text>
        </view.div>

        <view.div css={{stack: 'x', gap: 'small'}}>
          <Badge>
            <Text type="captionEmphasized" css={{color: 'inherit'}}>
              {intl.formatMessage(messages.installed)}
            </Text>
          </Badge>
          <Icon icon={chevronRight} size="xsmall" />
        </view.div>
      </view.div>
    </Action>
  );
};
